module.exports = __webpack_public_path__ + "static/img/icon_hjcx.f54fe68.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_hjcx.png
// module id = PHQH
// module chunks = 11